import { Stack } from "@certn/cascadia";
import { Divider, Pagination } from "@certn/cascadia-react";
import { SkeletonGrid } from "@certn/cascadia-react/patterns/skeleton-grid/SkeletonGrid";
import { useLocation, useNavigate } from "react-router-dom";

import { TaskRow } from "../../../components/tasks/TaskRow";
import { TasksEmptyState } from "../../../components/tasks/TasksEmptyState";
import { ActiveComplete, Schemas } from "../../../types";
import { TasksFilters } from "../TasksFilters";
interface Props {
  tab: ActiveComplete;
  isLoading: boolean;
  data?: Schemas["PaginatedClientPortalTasksListList"];
  params: {
    [k: string]: string;
  };
  handlePageChange: (page: number) => void;
  handlePageSizeChange: (pageCount: number) => void;
  handleTaskMutation: () => void;
}

export function TasksTab(props: Props) {
  const {
    tab,
    isLoading,
    data,
    params,
    handlePageChange,
    handlePageSizeChange,
    handleTaskMutation,
  } = props;
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <Stack gap="space-4">
      <TasksFilters isLoading={isLoading} />
      <Divider />
      {isLoading ? (
        <SkeletonGrid rows={3} columns={3} />
      ) : !data?.results?.length ? (
        <TasksEmptyState tab={tab} isSearching={false} />
      ) : (
        data.results.map((item, index) => (
          <div key={index}>
            <TaskRow
              isLoading={isLoading}
              task={item}
              onRowPress={() => {
                navigate(`/case-details/${item.case?.short_id}`, {
                  state: {
                    last: {
                      href: `${location.pathname}${location.search}`,
                    },
                  },
                });
              }}
              {...(tab === "ACTIVE" && {
                mutate: handleTaskMutation,
              })}
            />
            <Divider />
          </div>
        ))
      )}
      <Pagination
        isLoading={isLoading}
        setPage={handlePageChange}
        setPageCount={handlePageSizeChange}
        page={params.page ? Number(params.page) : 1}
        pageCount={params["page_size"] ? Number(params["page_size"]) : 25}
        total={data?.count ?? 0}
      />
    </Stack>
  );
}
